import axiosClient from "../axios/axiosClient";

export function getTechnologyInitiatives() {
  return axiosClient.get("/technology-initiatives");
}

export function getTechnologyInitiative(initiativeId) {
  return axiosClient.get(`/technology-initiatives/${initiativeId}`);
}

export function createTechnologyInitiative(data) {
  return axiosClient.post("/technology-initiatives", data);
}

export const updateTechnologyInitiative = (initiativeId, data) => {
  return axiosClient.put(`/technology-initiatives/${initiativeId}`, data);
};

export function deleteTechnologyInitiative(initiativeId) {
  return axiosClient.delete(`/technology-initiatives/${initiativeId}`);
}
